/* @flow */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
// $FlowIgnore
import { connect } from 'react-redux';

import TableDetailsLayout from 'components/layouts/TableDetailsLayout';
import { TransactionsTable } from 'components/Tables';
import TransactionDetails from 'components/DetailsPanels/TransactionDetails';
import TransactionsLink from 'components/Links/TransactionsLink';
import TransactionIcon from 'components/icons/TransactionIcon';
import { TransactionsToolbar } from 'components/Toolbars';
import {
  parsePaginationParams,
  shouldListRefresh
} from 'utils/location';
import { fetchTransactions } from 'ducks/list';
import { fetchTransaction, fetchDependents } from 'ducks/details';
import { flattenEntities } from 'utils/transactions';
import { HEADER_HEIGHT, TOP_NAV_HEIGHT } from '../style/dimensions';
import withRouting from 'utils/withRouting';

let PAGINATION_DEFAULTS = {
  sort: 'created_datetime',
  order: 'desc'
};

class Transactions extends Component {
  static propTypes = {
    router: PropTypes.any,
    list: PropTypes.any,
    details: PropTypes.any,
    dispatch: PropTypes.any,
    notifications: PropTypes.array,
  };

  componentDidMount() {
    this.getTransactions(this.props);
    let { did } = this.props.router.location.query;
    if (did) this.getTransaction(did);
  }

  componentDidUpdate(prevProps) {
    if (shouldListRefresh(this.props.router.location.query, prevProps.router.location.query) && !prevProps.list.isFetching) {
      this.getTransactions(this.props);
    }

    let pDid = prevProps.router.location.query.did;
    let nDid = this.props.router.location.query.did;

    if (nDid && pDid !== nDid && !prevProps.details.isFetching) {
      this.getTransaction(nDid);
    }

    let lastTx = prevProps.uploadTransactions.data.items[0];
    let nextTx = this.props.uploadTransactions.data.items[0];

    if (lastTx && nextTx && lastTx.state === 'LOADING' && nextTx.state !== 'LOADING') {
      this.getTransactions(nextProps);
      if (nDid) this.getTransaction(nDid);
    }
  }

  // $FlowIgnore
  getTransaction = id => {
    this.props.dispatch(fetchTransaction({ id })).then(({ payload }) => {
      let tx = payload.data.item[0];
      let entities = flattenEntities(tx.documents || []);

      let dependents = (entities.length && tx.state === 'FAILED' && tx.type === 'delete')
        ? (entities[0].errors[0] || { dependents: [] }).dependents
        : [];

      if (dependents.length) {
        this.props.dispatch(fetchDependents(dependents.map(x => x.id)));
      }
    });
  };

  getTransactions(props): void {
    let { first, offset, sort, order } = parsePaginationParams(props.router, PAGINATION_DEFAULTS);
    let { id, quickSearch, type, state, isDryRun, committable, closed } = props.router.location.query;
    let { params } = props.router;
    let { program, project } = params;
    props.dispatch(fetchTransactions({
      first, offset, sort, order, program, project, id, quickSearch, type, state, isDryRun, committable, closed
    }));
  }

  render(): React.Element {
    let { list: l, router, details, uploadTransactions, notifications } = this.props;
    let { sort, order } = parsePaginationParams(router, PAGINATION_DEFAULTS);

    let latestTx = uploadTransactions.data.items[0];

    let list = latestTx && latestTx.state === 'LOADING'
      ? {
        ...l,
        data: {
          ...l.data,
          items: [latestTx, ...l.data.items],
        },
      }
      : l;

    return (
      <TableDetailsLayout
        router={router}
        list={list}
        details={details}
        sort={sort}
        order={order}
        entity={'transaction'}
        IconComponent={TransactionIcon}
        TableComponent={TransactionsTable}
        DetailsComponent={TransactionDetails}
        LinkComponent={TransactionsLink}
        ToolbarComponent={TransactionsToolbar}
        height={`calc(100vh - ${(1 + notifications.filter(n => !n.dismissed).length) * HEADER_HEIGHT + TOP_NAV_HEIGHT}rem)`}
      />
    );
  }
}

export default connect(
  state => ({
    list: state.list,
    details: state.details,
    uploadTransactions: state.uploadTransactions,
    notifications: state.notifications,
  })
)(withRouting(Transactions));
